module.exports = __webpack_public_path__ + "img/row2.d8d3468.webp";